import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { BenefitNavigationExtensionInterface } from '../../../../extension/interface/benefit-navigation.extension.interface';
import { BenefitMenuItemInterface } from '../../nav/BenefitMenuItem';

export class ATMobilityBenefitNavigationExtension extends BenefitNavigationExtensionInterface {
  getMenuItems(): BenefitMenuItemInterface[] {
    const benefit = BenefitDTOBenefitEnum.AtMobility.toLowerCase();
    return [
      {
        title: 'subPage.employees',
        to: `/benefits/${benefit}`,
      },
      { title: 'AT_MOBILITY.receipts.title', to: `/benefits/${benefit}/receipts` },
      { title: 'subPage.settings', to: `/benefits/${benefit}/settings` },
      { title: 'subPage.payrollReport', to: `/benefits/${benefit}/payrollReport` },
    ];
  }
}
